"use client";

import React from "react";
import { Link, type LinkProps } from "@jasperlabs/ui";

import { useActiveTenant } from "@/tenants/TenantProvider";
import { withMailtoSubject } from "@/tenants/withMailtoSubject";

function TenantSupportLink({
	children = "Contact",
	subject,
	...props
}: Omit<LinkProps<"a">, "href" | "children"> & {
	children?: React.ReactNode;
	subject?: string;
}) {
	const tenant = useActiveTenant();
	const supportUrl = tenant?.supportUrl ?? "";

	return (
		<Link
			href={subject ? withMailtoSubject(supportUrl, subject) : supportUrl}
			target="_blank"
			{...props}
		>
			{children}
		</Link>
	);
}

export default TenantSupportLink;
